/**
 * Quando o cliente avisa o operador que está digitando.
 *
 * ## O defeito (Gisele, 23/10/2026)
 *
 * "Durante a conversa está apresentando indicação de que o cliente está
 * digitando mesmo quando ele não está realizando nenhuma ação."
 *
 * Eram duas causas, no mesmo lugar:
 *
 * 1. **A flag era um interruptor.** `setSendingMessage(!sendingMessage)` no
 *    `keypress`: a cada tecla ela invertia. Metade das teclas não avisava
 *    nada, e quando o cliente parava de digitar ela ficava ligada -- ninguém
 *    a desligava.
 *
 * 2. **O efeito que emitia o sinal dependia de `messages`.** Com a flag presa
 *    em ligado, TODA mensagem nova na conversa reemitia "digitando" -- o
 *    operador mandava uma mensagem e via o cliente "digitando" em resposta,
 *    sem o cliente ter tocado no teclado. É este o caso relatado.
 *
 * ## O desenho novo
 *
 * O que viaja agora é uma CONTAGEM de teclas, não um estado ligado/desligado.
 * Contagem só muda quando alguém digita, então o efeito que a observa não tem
 * como disparar por mensagem nova, por troca de sala ou por re-render: é a
 * diferença entre "o cliente está digitando" (um estado que alguém precisa
 * desligar, e ninguém desliga) e "o cliente digitou" (um fato que aconteceu).
 *
 * Desligar continua sendo do lado do operador, que já apaga o aviso sozinho
 * 1,5 s depois do último sinal.
 */

/**
 * O intervalo mínimo entre dois sinais, em milissegundos.
 *
 * Menor que o 1,5 s que o operador espera antes de apagar o aviso: com um
 * valor maior, quem digita sem parar veria o aviso piscar na tela do operador.
 * Com um valor muito menor, cada tecla viraria um pacote de socket -- numa
 * frase de 40 caracteres, 40 pacotes para dizer a mesma coisa.
 */
export const INTERVALO_ENTRE_SINAIS = 1000;

/**
 * Emite o sinal agora?
 *
 * @param {number|null} ultimoEnvioEm  `Date.now()` do último sinal, ou nulo
 * @param {number} agora               `Date.now()`
 * @param {number} [intervalo]
 */
export const deveEmitirSinal = (ultimoEnvioEm, agora, intervalo = INTERVALO_ENTRE_SINAIS) => {
    // A primeira tecla sempre avisa: esperar o intervalo para o primeiro sinal
    // atrasaria o aviso justo no momento em que ele é mais útil.
    if (ultimoEnvioEm == null) return true;

    return agora - ultimoEnvioEm >= intervalo;
};
